// extracted by mini-css-extract-plugin
module.exports = {"root":"📦ContactSelect__root--2oCiE","search":"📦ContactSelect__search---l8Z_","content":"📦ContactSelect__content--1mWgi","list":"📦ContactSelect__list--TSkF0"};